import { atom, selector } from "recoil";
import { 
	createDataRequest, 
	deleteAttachmentRequest, 
	updateDataRequest, 
	getClaimTypeListRequest, 
	getAddressListRequest, 
	getUserListRequest, 
	getDamageBagClaimListRequest, 
	getForwardTypeListRequest, 
	getBagStatusListRequest, 
	getArrivalFlightListRequest, 
	getDepartureFlightListRequest,
	receiveAllRequest,
	forwardAllRequest,
	deliverAllRequest,
	createNoteRequest
} from "../../../api/controller/CaseFileController";
import { pageState } from "../../../state/GlobalState";
import { permissionState, userState } from "../../../api/state/AuthState";
import moment from "moment";
import { bagArrivalFlightState, bagDepartureFlightState } from "../bags/state";

export const caseFileListState = atom({
    key: 'caseFileListState',
    default: [],
})
export const caseFileClaimTypeState = atom({
	key: 'caseFileClaimTypeState',
	default:{
		data:[],
		ovf:false,
	}
})
export const caseFileAddressState = atom({
	key: 'caseFileAddressState',
	default:{
		data:[],
		ovf:false,
	}
})
export const caseFileUserState = atom({
	key: 'caseFileUserState',
	default:{
		data:[],
		ovf:false,
	}
})
export const caseFileDamageBagClaimState = atom({
	key: 'caseFileDamageBagClaimState',
	default:{
		data:[],
		ovf:false,
	}
})
export const caseFileForwardTypeState = atom({
	key: 'caseFileForwardTypeState',
	default:{
		data:[],
		ovf:false,
	}
})
export const caseFileDPRActionState = atom({
	key: 'caseFileDPRActionState',
	default:{
		data:[],
		ovf:false,
	}
})
export const caseFileBagStatusState = atom({
	key: 'caseFileBagStatusState',
	default:{
		data:[],
		ovf:false,
	}
})
export const caseFileArrivalFlightState = atom({
	key: 'caseFileArrivalFlightState',
	default:{
		data:[],
		ovf:false,
	}
})
// export const bagArrivalFlightState = atom({
// 	key: 'bagArrivalFlightState',
// 	default:{
// 		data:[],
// 		ovf:false,
// 	}
// })
// export const bagDepartureFlightState = atom({
// 	key: 'bagDepartureFlightState',
// 	default:{
// 		data:[],
// 		ovf:false,
// 	}
// })

export const modalConfigDefault = { size: "xl", wizard: false }

export const filtersDefault = [
	{
        label: 'Period',
        size: 6,
        offset: 6,
        required: true,
        type: 'dateRange', // date, dateRange & select only
        value: [moment().format("YYYY-MM-DD"),moment().format("YYYY-MM-DD")], // String date "yyyy-mm-dd" for date | Array of 2 dates for dateRange | Object as shown for Select { label: "Label", value: 0 }
        list: [], // only for select -> Array should have Objects as shown { label: "Label", value: 0 }
    }
]

export const formModes = {
    create: [ { name: 'Default Create', action: createDataRequest } ], 
    update: [ { name: 'Default Update', action: updateDataRequest }, { name: 'Receive All', action: receiveAllRequest, closeOnSubmit: true }, { name: 'Forward All', action: forwardAllRequest, closeOnSubmit: true }, { name: 'Deliver All', action: deliverAllRequest, closeOnSubmit: true }, { name: 'Create Note', action: createNoteRequest, closeOnSubmit: true } ],
    view: [ { name: 'Default View' }, { name: 'Receipt' } ],
}

export const caseFileDataStructureState = selector({
    key: 'caseFileDataStructureState',
    get: ({ get }) => (
        [

            { 
				id: "X123",
                label: 'Type',
                type: 'select',
                order: { table: 1, form: 1 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6, lg: 3 }, default: 'AHL'  }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', { enabled: false }], 
				rootValue: true,
				list: {
					ovf: false,
					data:[
						{ label: 'AHL', value: 'AHL' },
						{ label: 'DPR', value: 'DPR' },
						{ label: 'OHD', value: 'OHD' },
						{ label: 'UNCLAIMED', value: 'UNCLAIMED' },
						{ label: 'CLAIMS', value: 'CLAIMS' },
					]
				},
            },
			{ 
                label: 'Reference',
				field: 'primary_reference',
                type: 'text',
                order: { table: 2 }, 
                create: [{ enabled: false  }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', { enabled: false }], 
            },
			{ 
                label: 'World Tracer Reference',
                type: 'text',
                order: { form: 2.1 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6, lg: 3 }, validations: 'hidden_if:Type,CLAIMS,UNCLAIMED'  }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', { enabled: false }], 
            },
			{ 
                label: 'Flight Date',
                type: 'datepicker',
                order: { table: 3, form: 3 }, 
				table: { dateFormat: 'MMM Do, YYYY', postDateFormat:'YYYY-MM-DD' },
                create: [{ enabled: true, size: { xs: 12, md: 6, lg: 3 } , loadCurrentDate: true, dateFormat: 'YYYY-MM-DD', options: { altInput: true, altFormat: 'F j, Y', dateFormat: 'Y-m-d' } }], 
				update: [{ enabled: true, size: { xs: 12, md: 6, lg: 3 } , dateFormat: 'YYYY-MM-DD', options: { altInput: true, altFormat: 'F j, Y', dateFormat: 'Y-m-d' } }, { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', { enabled: false }], 
				child: {
					name: "Flight",
					subFields: { label: "name", value: "name" }, 
					fn: getArrivalFlightListRequest
				}
            },
			{ 
                label: 'Flight',
                type: 'select',
				rootValue: true,
                order: { table: 4, form: 4 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6, lg: 3 }, validations: 'disabled_if:FlightDate,null', creatable: true  }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', { enabled: false }], 
				list: get(caseFileArrivalFlightState)
            },
			{ 
                label: 'Claim Type',
                type: 'select',
                order: { form: 5 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6, lg: 4 }, validations: 'hidden_if:Type,!CLAIMS'  }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', { enabled: false }], 
				list: get(caseFileClaimTypeState),
				getRequest: getClaimTypeListRequest,
            },
			{ 
                label: 'Claimed Item',
                type: 'text',
                order: { form: 6 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6, lg: 8 }, validations: 'hidden_if:Type,!CLAIMS'  }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', { enabled: false }], 
            },
			{ 
                label: 'Case Status',
                type: 'text',
                order: { table: 5, }, 
                create: [{ enabled: false }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', { enabled: false }], 
            },
			{ 
                label: 'Name',
                type: 'text',
                order: { table: 6, form: 8 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6, lg: 4 }  }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', { enabled: false }], 
            },
			{ 
                label: 'Address',
                type: 'select',
                order: { table: 7, form: 9 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6, lg: 4 }  }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', { enabled: false }], 
				list: get(caseFileAddressState),
				getRequest: getAddressListRequest,
            },
			{ 
                label: 'Bag Count',
				field: 'number_of_bags',
                type: 'number',
                order: { table: 7.1 }, 
                create: [{ enabled: false }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', { enabled: false }], 
            },
			{ 
                label: 'User',
                type: 'select',
                order: { form: 10 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6, lg: 4 }, default: (get(userState).id || '')  }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', { enabled: false }], 
				list: get(caseFileUserState),
				getRequest: getUserListRequest,
            },
			{ 
                label: 'Departure Date',
                type: 'datepicker',
                order: { form: 11 }, 
				table: { dateFormat: 'MMM Do, YYYY', postDateFormat:'YYYY-MM-DD' },
                create: [{ enabled: true, size: { xs: 12, md: 6, lg: 4 } , dateFormat: 'YYYY-MM-DD', options: { altInput: true, altFormat: 'F j, Y', dateFormat: 'Y-m-d' } }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', { enabled: false }], 
            },
			{ 
                label: 'Damage Bag Claim',
                type: 'select',
                order: { form: 12 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6, lg: 4 }, validations: 'hidden_if:Type,!DPR'  }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', { enabled: false }], 
				list: get(caseFileDamageBagClaimState),
				getRequest: getDamageBagClaimListRequest,
            },
			{ 
                label: 'Bags',
                type: 'repeater',
                order: { form: 13 },
                create: [{ enabled: true, size: { xs: 12, md: 12, lg: 12 }, deleteBtnSize: { xs: 2, md: 1 }, repeatLabel: true, divider: true }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', 'same_as:create.0'],
                children: [
                    { 
                		label: 'Tag Number',
                		type: 'text',
                		order: { form: 1 }, 
                		create: [{ enabled: true, size: { xs: 12, md: 6, lg: 4 }  }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', 'same_as:create.0'], 
            		},
					{ 
                		label: 'Bag Status',
                		type: 'select',
                		order: { form: 1.1 }, 
                		create: [{ enabled: true, size: { xs: 12, md: 6, lg: 4 }, default: 1  }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', 'same_as:create.0'], 
						list: get(caseFileBagStatusState),
						getRequest: getBagStatusListRequest,
            		},
					{ 
                		label: 'Arriving Flight',
						name: 'LocationHistory',
						field: 'location_history',
                		type: 'text',
                		order: { form: 1.2 }, 
                		create: [{ enabled: true, size: { xs: 12, md: 6, lg: 4 }, validations: 'hidden_if:BagStatus,TRACING|hidden_if:BagCaseType,DPR,OHD,UNCLAIMED' }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', { enabled: false }], 
            		},
					{ 
                		label: 'Receive Date',
                		type: 'datepicker',
                		order: { form: 2 }, 
						table: { dateFormat: 'MMM Do, YYYY', postDateFormat:'YYYY-MM-DD' },
                		create: [{ enabled: true, size: { xs: 12, md: 6, lg: 4 }, validations: 'hidden_if:BagStatus,TRACING,LOCATED', dateFormat: 'YYYY-MM-DD', options: { altInput: true, altFormat: 'F j, Y', dateFormat: 'Y-m-d' } }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', { enabled: false }], 
						child: {
							name: "ReceivedFlight",
							subFields: { label: "name", value: "name" }, 
							fn: getArrivalFlightListRequest
						}
            		},
					{ 
                		label: 'Received Flight',
                		type: 'select',
						rootValue: true,
                		order: { form: 3 }, 
                		create: [{ enabled: true, creatable: true, size: { xs: 12, md: 6, lg: 4 }, validations: 'hidden_if:BagStatus,TRACING,LOCATED|hidden_if:BagCaseType,UNCLAIMED,OHD|disabled_if:ReceiveDate,null' }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', { enabled: false }], 
						list: get(bagArrivalFlightState)
            		},
					{ 
                		label: 'Forward Date',
                		type: 'datepicker',
                		order: { form: 5 }, 
						table: { dateFormat: 'MMM Do, YYYY', postDateFormat:'YYYY-MM-DD' },
                		create: [{ enabled: true, size: { xs: 12, md: 6, lg: 4 }, validations: 'hidden_if:BagStatus,!FORWARDED', dateFormat: 'YYYY-MM-DD', options: { altInput: true, altFormat: 'F j, Y', dateFormat: 'Y-m-d' } }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', { enabled: false }], 
						child: {
							name: "ForwardFlight",
							subFields: { label: "name", value: "name" }, 
							fn: getDepartureFlightListRequest
						}
            		},
					{ 
                		label: 'Forward Flight',
                		type: 'select',
						rootValue: true,
                		order: { form: 6 }, 
                		create: [{ enabled: true, creatable: true, size: { xs: 12, md: 6, lg: 4 }, validations: 'hidden_if:BagStatus,!FORWARDED|disabled_if:ForwardDate,null' }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', { enabled: false }], 
						list: get(bagDepartureFlightState),
            		},
					{ 
                		label: 'Forward Type',
                		type: 'select',
                		order: { form: 7 }, 
                		create: [{ enabled: true, size: { xs: 12, md: 6, lg: 4 }, validations: 'hidden_if:BagStatus,!FORWARDED' }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', { enabled: false }], 
						list: get(caseFileForwardTypeState),
						getRequest: getForwardTypeListRequest,
            		},
					{ 
                		label: 'Rush Tag Number',
                		type: 'text',
                		order: { form: 8 }, 
                		create: [{ enabled: true, size: { xs: 12, md: 6, lg: 4 }, validations: 'hidden_if:BagStatus,!FORWARDED' }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', { enabled: false }], 
            		},
					{ 
                		label: 'Deliver Date',
                		type: 'datepicker',
						field: 'deliver_date_f',
                		order: { form: 8.1 }, 
						table: { dateFormat: 'HH:mm | MMM Do', postDateFormat:'YYYY-MM-DD HH:mm' },
                		create: [{ enabled: true, size: { xs: 12, md: 6, lg: 4 }, validations: 'hidden_if:BagStatus,!DELIVERED' , dateFormat: 'YYYY-MM-DD HH:mm', options: { altInput: true, enableTime: true, time_24hr: true, altFormat: 'H:i | F j, Y', dateFormat: 'Y-m-d H:i' } }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', 'same_as:create.0'], 
            		},
					{ 
                		label: 'Delivery Name',
                		type: 'text',
                		order: { form: 8.2 }, 
                		create: [{ enabled: true, size: { xs: 12, md: 6, lg: 4 }, validations: 'hidden_if:BagStatus,!DELIVERED' }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', 'same_as:create.0'], 
            		},
					{ 
                		label: 'Delivery Contact',
                		type: 'text',
                		order: { form: 8.3 }, 
                		create: [{ enabled: true, size: { xs: 12, md: 6, lg: 4 }, validations: 'hidden_if:BagStatus,!DELIVERED' }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', 'same_as:create.0'], 
            		},
					{ 
                		label: 'Delivery Identity',
                		type: 'text',
                		order: { form: 8.4 }, 
                		create: [{ enabled: true, size: { xs: 12, md: 6, lg: 4 }, validations: 'hidden_if:BagStatus,!DELIVERED' }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', 'same_as:create.0'], 
            		},
					{ 
                		label: 'Delivery Condition',
                		type: 'text',
                		order: { form: 8.41 }, 
                		create: [{ enabled: true, size: { xs: 12, md: 6, lg: 4 }, validations: 'hidden_if:BagStatus,!DELIVERED' }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', 'same_as:create.0'], 
            		},
					{ 
                		label: 'Delivery Signature',
                		type: 'signature',
                		order: { form: 8.5 }, 
                		create: [{ enabled: true, size: { xs: 12, md: 6, lg: 4 }, validations: 'hidden_if:BagStatus,!DELIVERED' }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', 'same_as:create.0'], 
            		},
					{ 
                		label: 'Damage Bag Receive Date',
                		type: 'datepicker',
                		order: { form: 8.01 }, 
                		create: [{ enabled: true, size: { xs: 12, md: 6, lg: 4 }, validations: 'hidden_if:BagCaseType,!DPR', dateFormat: 'YYYY-MM-DD', options: { altInput: true, altFormat: 'F j, Y', dateFormat: 'Y-m-d' } }], 
						update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], 
						view: [{ enabled: true, size: { xs: 12, md: 6, lg: 4 }, validations: 'hidden_if:Action,null' }, { enabled: false }],
            		},
					
                ]
            },
			{ 
                label: 'Color Type',
                type: 'text',
                order: { form: 14 }, 
                create: [{ enabled: true, size: { xs: 12 }, creatable: true  }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', { enabled: false }], 
            },
			{ 
                label: 'Remarks',
                type: 'textarea',
                order: { form: 14.1 }, 
                create: [{ enabled: true, size: { xs: 12 }, subText: "for Airline"  }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', { enabled: false }], 
            },
			{ 
                label: 'Attachments',
                type: 'dropzone',
                order: { form: 15 }, 
                create: [{ enabled: true, size: { xs: 12 }  }], update: ['same_as:create.0', { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: ['same_as:create.0', { enabled: false }], 
				deleteFn: deleteAttachmentRequest,
            },
			{ 
                label: 'Notes',
                type: 'repeater',
                order: { form: 15.01 },
                create: [{ enabled: false }], update: [{ enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: [{ enabled: true, size: { xs: 12, md: 12, lg: 12 }, deleteBtnSize: { xs: 2, md: 1 }, repeatLabel: true, divider: true }, { enabled: false }],
                children: [
                    { 
                		label: 'Note',
                		type: 'text',
                		order: { form: 1 }, 
                		create: [{ enabled: false }], update: [{ enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: [{ enabled: true, size: { xs: 12, md: 6, lg: 8 }  }, { enabled: false }], 
            		},
                    { 
                		label: 'User',
                		type: 'select',
                		order: { form: 2 }, 
                		create: [{ enabled: false }], update: [{ enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: [{ enabled: true, size: { xs: 12, md: 3, lg: 2 }  }, { enabled: false }], 
            		},
                    { 
                		label: 'Time',
                		type: 'datepicker',
						field: 'created_at',
                		order: { form: 3 }, 
                		create: [{ enabled: false }], update: [{ enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }, { enabled: false }], view: [{ enabled: true, size: { xs: 12, md: 3, lg: 2 }, dateFormat: 'MMM Do, HH:mm' }, { enabled: false }], 
            		},
				]
			},

			{
				label: 'Note',
				type: 'textarea',
				order: { form: 15.1 }, 
				create: [{ enabled: false }], 
				update: [
					'same_as:create.0',
					'same_as:create.0',
					'same_as:create.0',
					'same_as:create.0',
					{ enabled: true, size: { xs: 12 } },
				], 
				view: ['same_as:create.0', { enabled: false }],
            },




			{
				id: 'Y321',
				label: 'Date',
				type: 'datepicker',
				order: { form: 1 }, 
				table: { dateFormat: 'MMM Do, YYYY', postDateFormat:'YYYY-MM-DD' },
				create: [{ enabled: false }], 
				update: [
					'same_as:create.0',
					{ enabled: true, size: { xs: 12, md: 6 }, dateFormat: 'YYYY-MM-DD', loadCurrentDate: true, options: { altInput: true, altFormat: 'F j, Y', dateFormat: 'Y-m-d' } },
					'same_as:update.1',
					'same_as:create.0',
					'same_as:create.0',
				], 
				view: ['same_as:create.0', { enabled: false }], 
				child: {
					name: "Flight",
					subFields: { label: "name", value: "name" }, 
					fn: getArrivalFlightListRequest
				}
            },
			{
				id: 'Y321',
				label: 'Date',
				type: 'datepicker',
				order: { form: 1 }, 
				table: { dateFormat: 'MMM Do, YYYY', postDateFormat:'YYYY-MM-DD HH:mm' },
				create: [{ enabled: false }], 
				update: [
					'same_as:create.0',
					'same_as:create.0',
					'same_as:create.0',
					{ enabled: true, size: { xs: 12, md: 6 }, dateFormat: 'YYYY-MM-DD HH:mm', loadCurrentDate: true, options: { enableTime: true, altInput: true, altFormat: 'H:i | F j, Y', dateFormat: 'Y-m-d H:i' } },
					'same_as:create.0',
				], 
				view: ['same_as:create.0', { enabled: false }],
            },
			{
				label: 'Name',
				field: 'none',
				type: 'text',
				order: { form: 1.1 }, 
				create: [{ enabled: false }], 
				update: [
					'same_as:create.0',
					'same_as:create.0',
					'same_as:create.0',
					{ enabled: true, size: { xs: 12, md: 6 } },
					'same_as:create.0',
				], 
				view: ['same_as:create.0', { enabled: false }],
            },
			{
				label: 'Contact',
				type: 'text',
				order: { form: 1.2 }, 
				create: [{ enabled: false }], 
				update: [
					'same_as:create.0',
					'same_as:create.0',
					'same_as:create.0',
					{ enabled: true, size: { xs: 12, md: 6 } },
					'same_as:create.0',
				], 
				view: ['same_as:create.0', { enabled: false }],
            },
			{
				label: 'Identity',
				type: 'text',
				order: { form: 1.3 }, 
				create: [{ enabled: false }], 
				update: [
					'same_as:create.0',
					'same_as:create.0',
					'same_as:create.0',
					{ enabled: true, size: { xs: 12, md: 6 }, subText: "ID/Passport Number" },
					'same_as:create.0',
				], 
				view: ['same_as:create.0', { enabled: false }],
            },
			{
				label: 'Condition',
				type: 'text',
				order: { form: 1.31 }, 
				create: [{ enabled: false }], 
				update: [
					'same_as:create.0',
					'same_as:create.0',
					'same_as:create.0',
					{ enabled: true, size: { xs: 12, } },
					'same_as:create.0',
				], 
				view: ['same_as:create.0', { enabled: false }],
            },
			{
				label: 'Signature',
				type: 'signature',
				order: { form: 1.4 }, 
				create: [{ enabled: false }], 
				update: [
					'same_as:create.0',
					'same_as:create.0',
					'same_as:create.0',
					{ enabled: true, size: { xs: 12 } },
					'same_as:create.0',
				], 
				view: ['same_as:create.0', { enabled: false }],
            },
			{ 
                label: 'Flight',
				field: 'none',
                type: 'select',
				rootValue: true,
                order: { form: 2 }, 
                create: [{ enabled: false }], 
				update: [
					'same_as:create.0', 
					{ enabled: true, creatable: true, size: { xs: 12, md: 6 }, validations: 'disabled_if:Date,null' }, 
					'same_as:update.1', 
					'same_as:create.0',
					'same_as:create.0',
				], 
				view: ['same_as:create.0', { enabled: false }], 
				list: get(caseFileArrivalFlightState)
            },
			{ 
				label: 'Forward Type',
				type: 'select',
				order: { form: 3 }, 
				create: [{ enabled: false }], 
				update: [
					'same_as:create.0', 
					'same_as:create.0', 
					{ enabled: true, size: { xs: 12, md: 6 } }, 
					'same_as:create.0',
					'same_as:create.0',
				], 
				view: ['same_as:create.0', { enabled: false }], 
				list: get(caseFileForwardTypeState),
				getRequest: getForwardTypeListRequest,
			},
			{ 
				label: 'Rush Tag Number',
				type: 'text',
				order: { form: 4 }, 
				create: [{ enabled: false }], 
				update: [
					'same_as:create.0', 
					'same_as:create.0', 
					{ enabled: true, size: { xs: 12, md: 6 } }, 
					'same_as:create.0',
					'same_as:create.0',
				], 
				view: ['same_as:create.0', { enabled: false }], 
			},

        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
